// default user:
// Username:admin
// Email: admin@quivyo.com
// Password: Admin123
// bojocid814@tupanda.com
// xaxid51715@seosnaps.com
// diremop192@tospage.com local
// pofite8101@seosnaps.com local
// jajeva9453@massefm.com
// diwoc23572@minhlun.com
// vicemar566@minhlun.com
// test1@ricorit.com
// test12@gmail.com
// test22@gmail.com
// test1@test.com
// test2@test.com
// test3@test.com
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import resources from "./assets/locales/resources";
import {
  I18nextProvider,
  initReactI18next,
  useTranslation,
} from "react-i18next";
import i18next from "i18next";
import "./assets/styles/index.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import environment from "./environment";

const _lang = environment.LANGUAGE;

if (!localStorage.getItem(_lang)) {
  localStorage.setItem(_lang, "ar");
}

i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem(_lang),
  resources,
});

const Main = () => {
  const { t, i18n } = useTranslation();

  if (i18n.language === "en") {
    import("bootstrap/dist/css/bootstrap.min.css");
  } else {
    import("bootstrap/dist/css/bootstrap.rtl.min.css");
  }

  return (
    <React.Fragment>
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </Provider>
    </React.Fragment>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<Main />);
